import { h, img, link, p, youtube } from '@/content/blocks'
import type { Project } from '@/types/content'

const project: Project = {
  slug: 'automated-sorting-system',
  title: 'Automated Sorting System',
  summary: 'An automated sorting system for recycling.',
  cover: {
    src: '/assets/P3-QARM.png',
    alt: 'Quanser QArm robotic arm with its three-fingered gripper and wrist-mounted camera',
  },
  tags: ['Programming', 'Robotics'],
  order: 5,
  blocks: [
    p('As a preface, a more rigorous and thorough engineering design process was used to create the system. However, I hope to provide a general understanding of how it was create and how it works.'),

    h('Problem'),
    p([
      'There is a glaringly overlooked issue with recycling, where the number of items sent to the recycling is not recycled. According to the ',
      link('City of Toronto', 'https://www.toronto.ca/services-payments/recycling-organics-garbage/houses/what-goes-in-my-blue-bin/'),
      ', 30% of items sent to recycling are not recyclable. As a result, the process of sorting in recycling facilities is much more complicated due whether it be from food or drink residue will affect recyclability.',
    ]),

    h('Problem Statement'),
    p('In a controlled environment, we can simulate the process of sorting materials and determining where to designate it for recycling. The goal of this project was to design a system which sorts and recycles through all kinds of material based on their classification to prevent improper recycling and reduce the excess waste that enters our landfills and recycling facilities.'),

    h('Our Approach'),
    p('Through using Quanser Lab simulation, an algorithm was designed using Python that would transfer containers from the sorting station to the correct bin the recycling station. This would require us to host the simulation through a Raspberry Pi through which we would also be able to locally connect to simulate the system physically.'),
    img('/assets/P3-SimulatedEnvironment.png', 'Quanser Lab simulated environment showing the sorting station, the Q-Arm, the Q-Bot and the recycling bins'),

    h('Sorting'),
    p('Sensors were used to determine what type of container was being processed and loaded. For example, using an inductive sensor would tell us if the container is metal can or not. From there, a photoelectric sensor is used to determine whether the material is plastic or paper. Generally, the paper recyclables will have a higher raw reading on the photoelectric sensors than plastic containers which will allow for us to differentiate between the two.'),

    h('Loading'),
    p('Knowing which container is on the sorting station will allow us to determine where they should be allocated (to their respective bins). The Q-Arm loads a maximum of three containers given that they are all in the same category of recyclables (and stops loading once a different bin target is introduced).'),

    h('Transporting'),
    p('The Q-Bot (the roomba) is programmed to follow the yellow path using a basic algorithm that implements infrared sensors. There are two infrared sensors on each end of the Q-Bot wheel and moves straight when the yellow line is detected. However, if only the right sensor detects the yellow path, the wheel speed of the left side moves faster to correct the angle and vice versa.'),

    h('Depositing'),
    p('There were many approaches to differentiate between each bin. For our instance, ultrasonic sensors were used to calibrate distances away from the bin which would allow us to find the corresponding bin.'),

    youtube('JQcOYYbJmE0', 'Recycling sorting system running in the Quanser Lab simulation'),

    p('Source code available upon request. Just send me an email!'),
  ],
}

export default project
